export default "__VITE_ASSET__5be96b0e__"